RivalIQ.apps.Admin.module('collections', function (collections, Admin, Backbone, Marionette, $, _) {

    'use strict';

    collections.EditHistory = Backbone.Collection.extend({
        initialize: function (data) {
            const me = this;
            me.url = `/admin/api/companies/${data.companyId}/editHistory`;
        }
    });
});
